module.exports = __webpack_public_path__ + "static/media/cafe_01.9bb79819.svg";